<template>
  <v-app>
    <main-app-bar></main-app-bar>
    <v-main class="hk-app-bg" :style="{ backgroundImage: 'url(' + baseImg + ')' }">
      <section class="hk-section">
        <div class="hk-wrap">
          <h1 class="hk-heading hk-heading--accent mb-3">Lépj velünk kapcsolatba</h1>
          <p class="hk-lead text-center mb-10">Kérdésed van, vagy ajánlatot kérnél? Elérhetőségeink egyikén szívesen segítünk.</p>

          <v-card class="hk-card pa-4 pa-md-8 mb-8">
            <connection-row></connection-row>
          </v-card>

          <v-card class="hk-card map-card">
            <iframe
                class="map-frame"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1626.1723109460793!2d19.866653731243492!3d46.72773102185655!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4743e9006da49731%3A0xce556a9025c7c1cb!2zS3JlYXTDrXYgSMOtbXrFkWt1Y2vDsw!5e0!3m2!1shu!2shu!4v1734196153637!5m2!1shu!2shu"
                allowfullscreen=""
                loading="lazy"
                referrerpolicy="no-referrer-when-downgrade">
            </iframe>
          </v-card>
        </div>
      </section>
    </v-main>
  </v-app>
</template>

<script lang="ts">
import {Options, Vue} from "vue-class-component";
import MainAppBar from "@/components/MainAppBar.vue";
import ConnectionRow from "@/components/ConnectionRow.vue";

@Options({
  components: {ConnectionRow, MainAppBar},
  data() {
    return {
      baseImg: require("@/assets/base.png"),
    };
  }
})
export default class ConnectionView extends Vue {
}
</script>

<style scoped>
.map-card {
  overflow: hidden;
  padding: 0;
}

.map-frame {
  display: block;
  width: 100%;
  height: 460px;
  border: 0;
}
</style>
